import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError, of } from 'rxjs';
import Swal from 'sweetalert2';
import { environment } from '../../environments/environment';
@Component({
  selector: 'app-documento-institucion',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule],
  templateUrl: './documento-institucion.component.html',
  styleUrl: './documento-institucion.component.css',
})
export class DocumentoInstitucionComponent implements OnInit {
  documentoForm!: FormGroup;
  id_documento_cargado!: number;
  historialAdmin: any[] = [];
  historialInstitucion: any[] = [];

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.documentoForm = this.fb.group({
      nombre: [{ value: '', disabled: true }],
      estado_actual: [{ value: '', disabled: true }],
      estado: [{ value: '', disabled: true }], // Se habilita para cambiar el estado
      fecha_subida: [{ value: '', disabled: true }],
      link_archivo: [{ value: '', disabled: true }],
      institucion: [{ value: '', disabled: true }],
      director: [{ value: '', disabled: true }],
    });

    this.route.queryParams.subscribe((params) => {
      this.id_documento_cargado = params['id_documento_cargado'];
    });


    if (!this.id_documento_cargado) {
      Swal.fire('Error', 'Documento no válido.', 'error').then(() => {
        this.router.navigate(['/documentos-institucion']);
      });
      return;
    }

    this.cargarDocumento();
    this.cargarHistorialAdmin();
    this.cargarHistorialInstitucion();
  }

  cargarDocumento(): void {
    this.http
      .get(
        environment.apiUrl + `/documento-cargado/${this.id_documento_cargado}`
      )
      .pipe(catchError(() => of(null)))
      .subscribe((response: any) => {
        if (response) {
          this.documentoForm.patchValue({
            nombre: response.nombre || '',
            estado: response.estado || '',
            fecha_subida: response.fecha_subida
              ? response.fecha_subida.split('T')[0]
              : '',
            link_archivo: response.link_archivo || '',
            institucion:
              response.institucionEducativa?.cen_edu || 'No disponible',
            director:
              response.institucionEducativa?.director || 'No disponible',
          });

        }
      });
  }

  cargarHistorialAdmin(): void {
    this.http
      .get(
        environment.apiUrl + `/historial-admin?id_documento_cargado=${this.id_documento_cargado}`
      )
      .pipe(catchError(() => of([])))
      .subscribe((response: any) => {
        if (Array.isArray(response)) {
          this.historialAdmin = response.map((item) => ({
            accion: item.accion || '',
            fecha: item.fecha || '',
            observacion: item.observacion || '',
            usuarioNombreCompleto: `${item.rolUsuario.usuario?.nombres || ''} ${
              item.rolUsuario.usuario?.apellidos || ''
            }`.trim(),
          }));
        } else {
          this.historialAdmin = [];
        }
      });
  }

  cargarHistorialInstitucion(): void {
    this.http
      .get(
        environment.apiUrl + `/historial-institucion?id_documento_cargado=${this.id_documento_cargado}`
      )
      .pipe(catchError(() => of([])))
      .subscribe((response: any) => {
        if (Array.isArray(response)) {
          this.historialInstitucion = response.map((item) => ({
            accion: item.accion || '',
            fecha: item.fecha || '',
            link_archivo: item.link_archivo || '',
          }));
        } else {
          this.historialInstitucion = [];
        }
      });
  }

  goToUpdate(): void {
    this.router.navigate(['/update-documento-cargado'], {
      queryParams: { id_documento_cargado: this.id_documento_cargado },
    });
  }

  volver(): void {
    this.router.navigate(['/documentos-institucion']);
  }
}
